import React from "react";

import PoliticaCalidadMedioAmbiente from '../../../assets/files/PoliticaCalidadMedioAmbiente.svg'

import PoliticaSeguridadInformacion from '../../../assets/files/PoliticaSeguridadInformacion.svg'

import PoliticadeCalidadOIP from '../../../assets/files/PoliticadeCalidadOIP.svg'

function Politics() {
    return (
        <>
            <div
                className="page-header section-dark"
                style={{
                    backgroundColor: "#4d4d4d",
                }} />

            <style>
                {".page-header {height: 80px; min-height: unset}"}
            </style>

            <div className="Politics-Page">
                <h1>Política de calidad</h1>

                <img onClick={() => window.open("/files/PoliticadeCalidadOIP.pdf", "Popup", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30")}
                    src={PoliticadeCalidadOIP} alt="PDF" className="Document" />
            </div>
        </>
    )
}
export default Politics;